import { useState } from "react";
import { Copy, Check } from "lucide-react";

export const CONTRACT_ADDRESS = "AnAeGUt27n4mXwT8djwbd4QJAytF2ZPKtaszPak1pump";
export const PUMP_FUN_URL = `https://pump.fun/coin/${CONTRACT_ADDRESS}`;
export const DEXSCREENER_URL =
  "https://dexscreener.com/solana/j15hmrrrtsibcypir2qk5cjzkwddjapj3ku8cnxbvq5k";

export default function ContractAddress({ variant = "default" }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CONTRACT_ADDRESS);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (e) {
      // noop
    }
  };

  const truncated = `${CONTRACT_ADDRESS.slice(0, 6)}...${CONTRACT_ADDRESS.slice(-6)}`;

  return (
    <div
      data-testid="contract-address-box"
      className={`inline-flex items-center gap-2 px-3 py-2 border border-[#00F0FF]/30 bg-[#0B0B12]/80 backdrop-blur-md ${
        variant === "default" ? "max-w-full" : ""
      }`}
    >
      <span className="font-mono text-[10px] tracking-[0.3em] text-white/50 hidden sm:inline">
        CA:
      </span>
      <span
        data-testid="contract-address-value"
        className="font-mono text-xs sm:text-sm text-white truncate"
        title={CONTRACT_ADDRESS}
      >
        <span className="sm:hidden">{truncated}</span>
        <span className="hidden sm:inline">{CONTRACT_ADDRESS}</span>
      </span>
      <button
        data-testid="contract-copy-btn"
        onClick={copy}
        className="ml-1 inline-flex items-center justify-center w-7 h-7 border border-[#00F0FF]/40 bg-[#00F0FF]/10 text-[#00F0FF] hover:bg-[#00F0FF] hover:text-black transition-colors"
        aria-label="Copy contract address"
      >
        {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
      </button>
    </div>
  );
}
